export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  toggle: "nav-toggle",
  linkReviews: "nav-link-reviews",
  linkPackages: "nav-link-packages",
  linkTowns: "nav-link-towns",
  linkFaq: "nav-link-faq",
  ctaBook: "nav-cta-book",
  ctaQuote: "nav-cta-quote",
};

export const HERO = {
  root: "hero",
  ratingBadge: "hero-rating-badge",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const REVIEWS = {
  section: "reviews-section",
  card: (i) => `review-card-${i}`,
  source: (i) => `review-source-link-${i}`,
  viewAll: "reviews-view-all",
};

export const PACKAGES = {
  section: "packages-section",
  card: (slug) => `package-card-${slug}`,
  cta: (slug) => `package-cta-${slug}`,
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FORM = {
  root: "quote-form",
  name: "quote-form-name",
  email: "quote-form-email",
  phone: "quote-form-phone",
  date: "quote-form-date",
  venue: "quote-form-venue",
  town: "quote-form-town",
  message: "quote-form-message",
  submit: "quote-form-submit",
  success: "quote-form-success",
  error: "quote-form-error",
};

export const TOWN = {
  page: (slug) => `town-page-${slug}`,
  hero: "town-hero",
};

export const FOOTER = {
  root: "footer",
  bookCta: "footer-book-cta",
  hitchedLink: "footer-hitched-link",
};
